import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { authActions } from 'state/auth/auth.actions';
import { AppState } from 'state/reducer';
import { MfaLoginTemplate } from 'common/templates/MfaLoginTemplate';

const mapStateToProps = (state: AppState) => ({
  loading: state.auth.loading,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      onSubmit: authActions.mfaLogin,
    },
    dispatch
  );

export const MfaLoginPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(MfaLoginTemplate);
